import { DataTableColumnFilterProps } from '../../../components/Common/DataTable/DataTableColumnFilter';
import {
  DatabaseOfferWithApprovalRequest,
  OfferState,
} from '../../../../../shared/types/offers';
import { getOfferStateLabel } from '../helpers';
import { RenderComponentPropsParent } from './OfferSheetsTable';

type OffersTableColumnFilterProps = RenderComponentPropsParent<
  DataTableColumnFilterProps<DatabaseOfferWithApprovalRequest>['renderColumnFilter']
>;

export const OffersTableColumnFilter: OffersTableColumnFilterProps =
  ({
    key,
    filterComponentProps,
    InputFilter,
    SelectFilter,
    DateFilter,
  }) => {
    switch (key) {
      // NUMBER INPUT
      case 'id':
        return (
          <InputFilter
            {...filterComponentProps}
            inputProps={{ type: 'number', min: '1' }}
          />
        );
      case 'totalPrice':
      case 'totalCoefficient':
        return (
          <InputFilter
            {...filterComponentProps}
            inputProps={{ type: 'number' }}
          />
        );
      // TEXT INPUT
      case 'customerName':
      case 'name':
      case 'userEmail':
      case 'worksite':
      case 'responsibleWarehouseName':
        return <InputFilter {...filterComponentProps} />;
      // SELECT
      case 'state': {
        const getOptions = (array: OfferState[]) =>
          array.map((state) => ({
            key: state,
            label: getOfferStateLabel(state),
          }));
        let selectFilterOptions = getOptions(
          Object.values(OfferState),
        );

        return (
          <SelectFilter
            {...filterComponentProps}
            options={selectFilterOptions}
          />
        );
      }
      // DATE
      case 'createdAt':
      case 'offerValidityEnd':
        return <DateFilter {...filterComponentProps} />;
    }
  };
